export function visibleInViewport(element, returnPercentages = false) {
    if (!element || !(element instanceof Element)) {
        console.error('Invalid element provided')
        return
    }

    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight
    const windowWidth = window.innerWidth || document.documentElement.clientWidth

    // Check if the element is within the viewport on both x and y axes
    const isVisible = rect.top <= windowHeight && rect.bottom >= 0 && rect.left <= windowWidth && rect.right >= 0

    if (isVisible) {
        if (returnPercentages) {
            // Calculate the visible height and width
            const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0)
            const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0)

            // Calculate the visible area and the total area
            const visibleArea = visibleHeight * visibleWidth
            const totalArea = rect.height * rect.width

            // Calculate the percentage of visible area relative to the total area
            const percentageVisible = (visibleArea / totalArea) * 100
            const percentageVisibleHeight = (visibleHeight / rect.height) * 100
            const percentageVisibleWidth = (visibleWidth / rect.width) * 100
            return {
                visible: true,
                percentageVisible: percentageVisible,
                percentageVisibleY: percentageVisibleHeight,
                percentageVisibleX: percentageVisibleWidth
            }
        } else {
            return true
        }
    } else {
        if (returnPercentages) {
            return {
                visible: false,
                percentageVisible: 0,
                percentageVisibleY: 0,
                percentageVisibleX: 0
            }
        } else {
            return false
        }
    }
} 